/**
 * Metering Service Layer
 *
 * - Call each metering endpoint directly.
 */

import api from "./api";
import URLS from "../../src/utils/urls";

const ENDPOINTS = {
  overviewContracted: `${URLS.BACKEND_API}/api/metering/get_capacity_info`,
  tableDetails: `${URLS.BACKEND_API}/api/metering/get_capacity_details`,
  tableContracts: `${URLS.BACKEND_API}/api/metering/get_contract_info`,
  customerContracts: `${URLS.BACKEND_API}/api/metering/get_customer_contracts`,
  capacityDownloadCSV: `${URLS.BACKEND_API}/api/metering/get_capacity_details_csv`,
  contractsDownloadCSV: `${URLS.BACKEND_API}/api/metering/get_contract_info_csv`,
  addAsset: `${URLS.BACKEND_API}/api/metering/add_asset`
};

/**
 * ADD/GET ASSETS ENDPOINTS
 * Returns customer contracts
 * Dispatched by: MeteringAddAssetSlider component on mount
 * Displayed in: Metering Add Asset Slider
 */

export const getCustomerContracts = () => {
  return api.get(ENDPOINTS.customerContracts);
};

export const addMeteringAssets = assets => {
  return api.post(ENDPOINTS.addAsset, {
    assets
  });
};

export const getMeteringOverviewContracted = payload => {
  return api.get(ENDPOINTS.overviewContracted, {
    params: payload
  });
};

/**
 * TABLE ENDPOINTS
 * Returns arrays with rows data for MeteringDataTable component
 */
export const getMeteringTableDetails = async payload => {
  const tableData = await api.get(ENDPOINTS.tableDetails, {
    params: payload
  });

  return Array.isArray(tableData) ? tableData : tableData?.rows || [];
};

export const getMeteringContractsTable = async () => {
  const tableData = await api.get(ENDPOINTS.tableContracts);
  return Array.isArray(tableData) ? tableData : tableData?.rows || [];
};

//CSV download endpoints
export const getCapacityReportCSV = payload => {
  return api.post(ENDPOINTS.capacityDownloadCSV, payload, {
    responseType: "blob"
  });
};

export const getContractsReportCSV = payload => {
  return api.post(ENDPOINTS.contractsDownloadCSV, payload, {
    responseType: "blob"
  });
};
